// extracted by mini-css-extract-plugin
module.exports = {"trial":"trial_trial__6353V"};